import { Descendant } from 'slate'
import { ITextWidgetParameter, ITextWidgetSettings } from './textChart.types'

const generateEmptyParameterText = (): ITextWidgetParameter => {
  return { deviceId: null, parameterId: null }
}

const generateEmptyText = (): Descendant[] => [
  {
    children: [
      { type: 'text', text: 'Показания основного датчика: ', fontSize: 14 },
      { type: 'parameter', text: '$1', fontSize: 14 },
    ],
  },
]

const generateEmptyChartTextSettings = (): ITextWidgetSettings => {
  return {
    parametersText: [generateEmptyParameterText()],
    title: '',
    text: generateEmptyText(),
  }
}

const textChartUtils = { generateEmptyChartTextSettings, generateEmptyParameterText, generateEmptyText }
export default textChartUtils
